import Vue from 'vue'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import Utils from '../../utils'
import i18n from './i18n'


const moment = require('moment-timezone');
moment.tz.setDefault('Europe/Bratislava');

import VueLocalStorage from 'vue-ls';
let options = {
  namespace: 'shmu__'
};

Vue.use(Utils);
Vue.use(VueLocalStorage, options);
Vue.use(VueMoment, {
  moment,
});

Vue.use(VueAxios, axios)
Vue.config.productionTip = false

let language = 'sk';
if (window.wn_lang) {
  language = window.wn_lang;
}

i18n.locale = language;



Vue.mixin({
  methods: {
    notEmptyObject(someObject){
      return Object.keys(someObject).length
    }
  }
})

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
